const getCalendars = (state) => {
  return state.calendars;
}

const getCalendar = (state) => {
  return state.calendar;
}

const getCalendarMeta = (state) => {
  return state.calendarMeta;
}

const getEvents = (state) => {
  return state.events;
}

const getEvent = (state) => {
  return state.event;
}

const getParticipants = (state) => {
  return state.participants;
}

const getParticipantById = (state) => id => {
  return state.participants.find(i => i.id === id);
}

/* ASSIGNMENT */
const getAssignment = state => {
  return state.assignment;
}

const getIsEditable = state => state.isEditable;

const getLoadingCalendars = (state) => {
  return state.loadingCalendars;
}

const getLoadingEvents = (state) => {
  return state.loadingEvents;
}

export default {
  getCalendars,
  getCalendar,
  getCalendarMeta,

  getEvents,
  getEvent,

  getParticipants,
  getParticipantById,

  getAssignment,

  getIsEditable,

  getLoadingCalendars,
  getLoadingEvents,
}
